<template>
  <div class="busAdvertiser">
    <template>
      <div class="busAdvertiser__header">
        <div class="busAdvertiser__header__top-left">
          <div class="busAdvertiser__header__left__search">
            <span class="icon"><i class="adx-ic_search"></i></span>
            <input v-model="searchText" type="text" class="search subhead" placeholder="Search campaign name">
          </div>
        </div>
         <div class="busAdvertiser__header__right">
          <p>Sort by :</p>
          <div>
            <adx-dropdown-sort :value.sync="selectedSortValue" :type="true" :options="sort"></adx-dropdown-sort>
          </div>
      </div>
      </div>
      <div class="busAdvertiser__body">
        <adx-table :items="busCampaign" @selectedAction="selectedAction" :loading.sync="isLoading">
          <span slot="content" class="btn-plus">
            <i class="adx-ic_plus"></i>
          </span>
        </adx-table>
      </div>
      <div v-if="!loadingData && campaigns.length > 0" class="busAdvertiser__footer">
        <adx-pagination 
          @change-page="selectPage" 
          :maxPage="maxPage" 
          :selectedPage="selectedPage" />
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import Input from '@/components/Form/Input'
import Dropdown from '@/components/Dropdown/ListDropdown'
import Empty from '@/components/NotFound/Selection'
import Pagination from '@/components/Pagination'
import Loading from '@/components/Loading/Primary'
import Tooltip from '@/components/Tooltip'
import DropdownSort from '@/components/Form/SelectDropdown'
import table from '@/components/Table'
import LabelStatus from '@/components/StatusLabel'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import lib from '@/lib/util'
import { helpers } from '@/lib/validation/'
import { formatShortDate } from '@/lib/util'

export default {
  name: 'adx-dashboard-advertiser',
  components: {
    'adx-input': Input,
    'adx-dropdown': Dropdown,
    'adx-empty': Empty,
    'adx-pagination': Pagination,
    'adx-loading': Loading,
    'adx-dropdown-sort': DropdownSort,
    'tooltip': Tooltip,
    'adx-table': table,
    LabelStatus
  },
  props: {

  },
  data() {
    return {
      campaigns: [],
      filteredCampaigns: [],
      searchText: '',
      selectedPage: 1,
      maxPage: 1,
      isLoading: false,
      loadingData: false,
      selectedSortValue: 'last_updated',
      sort: [
        {
          'id': 0,
          'label': 'Last Updated',
          'value': 'last_updated'
        },
        {
          'id': 1,
          'label': 'Created Date',
          'value': 'created'
        }
      ],
      busCampaign: {
        checkbox: false,
        head: [
          {
            title: "CAMPAIGN NAME",
            type: "text"
          },
          {
            title: "PERIOD",
            type: "text"
          },
          {
            title: "",
            type: "icon"
          },
        ],
        body: []
      }
    }
  },
  computed: {
    
  },
  watch: {
    searchText: helpers.debounce(function () {
      this.$nextTick(function () {
        this.loadData()
      })
    }, 500),
    selectedSortValue: function () {
      this.loadData()
    },
  },
  beforeCreate() {

  },
  created() {
    this.loadData()
  },
  beforeMount() {
    // this.isLoading = true
    // this.getCampaigns()
    // this.isLoading = false
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async loadData() {
      this.isLoading = true
      this.busCampaign.body = []

      let params = {
        search: this.searchText,
        ordering: this.selectedSortValue
      }
      const { data, status } = await api.get(apiV2.busMeasurementCampaign, { needToken: true, params: params })

      if (status == 200) {
        data.map(obj => {
          let date = `${formatShortDate(obj.start_date)} - ${formatShortDate(obj.end_date)}`

          this.busCampaign.body.push({
            id: obj.id,
            values: [
              { value: obj.name },
              { value: date},
              { icon: "icon-copy", text: "View Report"}
            ]
          })
        })
      } else {
        this.$notify({
          group: 'saved',
          title: 'Error',
          text: 'Oops something went wrong',
          type: 'danger'
        });
      }

      this.isLoading = false
    },
    selectedAction(id, type, item){
      if(type == 'icon-copy'){
        let range = item.values[1].value
        let end = range.split(' - ').pop()
        let start = range.split(' - ').shift()
        // console.log(start)
        // console.log(end)
        this.$router.push({name: 'busreport', params: { id: item.id, start_date: item.start_date, end_date: item.end_date}})
      }
    },
    selectStatus(item) {
      this.selectedStatus = item.value
      this.selectedLabel = item.label
      // this.getCampaigns()
    },
    selectPayment(){

    },
    setItem(){

    },
    selectPage(page) {
      this.selectedPage = page
      // this.getCampaigns()
    },
    displayPeriod(start, end) {
      let startDate = moment(start, 'YYYY-MM-DD')
      let endDate = moment(end, 'YYYY-MM-DD')
      if (startDate.year() == endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', end)}`
      } else if (startDate.year() < endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', end)}`
      }
    },
    displayStatus(status) {
      return lib.displayCampaignStatus(status)
    },
    isEmpty() {
      if (this.campaigns.length == 0) {
        return true
      }

      return false
    },
    getStatusClass(status) {
      status = status.toLowerCase()
      if (status == 'waiting for approval') {
        return 'wfa'
      } else if (status == 'waiting for payment') {
        return 'wfp'
      } else if (status == 'active') {
        return 'active'
      } else if (status == 'upcoming') {
        return 'upcoming'
      }
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang="scss">
.advertiser {
  .menu {
    width: 180px;
  }

.container-router{
  width: 100%;
  max-width: 100%;
}

  .dropdown {
    &__menu {
      min-width: 180px;
    }
  }
}

.busAdvertiser {
  .emptySelection {
    margin-top: 120px;
  }
}
</style>
